const prefix = 'admin';

export const getSubscriptions = `${prefix}/subscriptions`;
export const createSubscription = `${prefix}/subscriptions`;
export const updateSubscription = (id: string) => `${prefix}/subscriptions/${id}`;
export const getSubscriptionSubscribers = `${prefix}/subscriptions/subscribers`;
export const getSubscriptionDailyStats = (from: string, to: string) =>
    `subscriptions/stats/daily?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`;
